import { currencyUtils } from '~/utils/currency.utils';
export const formatYearlyAmount = (amount)=>currencyUtils.formatDollarAmount(Math.round(amount / 10) * 10);
